import { render } from "./order-billing.vue?vue&type=template&id=531a3ec2&scoped=true"
import script from "./order-billing.vue?vue&type=script&lang=js"
export * from "./order-billing.vue?vue&type=script&lang=js"

import "./order-billing.vue?vue&type=style&index=0&id=531a3ec2&scoped=true&lang=css"

import exportComponent from "D:\\Development\\VSTS.Git\\FleuristeBergeron\\Spec_2.0\\Solutions\\WWW\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531a3ec2"]])

export default __exports__